import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      permissionGroups: 'common/permissionGroups'
    }),
    hasPermission() {
      return (permissionType, permissionCode) => {
        if (permissionType === 'CREATOR') {
          return false
        }
        const target = this.permissionGroups.find((item) => item.permissionType === permissionType)
        if (!target?.permissionItemCodes.includes(permissionCode)) {
          return true
        }
        // 如果没有找到，返回null
        return null
      }
    },
  },
  methods: {
    ...mapActions({
      getPermissionGroups: 'common/getPermissionGroups'
    }),
    async getPermissionGroups() {
      await this.getPermissionGroups()
    }
  },
}
